import { ApiService } from '@stores/ApiService';
import { IApiService } from '@stores/IApiService';
import { ApiResponse, apiResponse } from '@stores/index';
import { Lookup } from '@views';

export class NotificationPreferencesStore {
  constructor(private readonly api: IApiService = new ApiService()) {}

  public async readAll(): Promise<ApiResponse<NotificationPreference[]>> {
    try {
      const response = await this.api.get('/notification-preferences');
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}

export type NotificationPreference = {
  id: number;
  name: string;
  recommendedPreference: number;
};
